import React from 'react';
import styles from './Support.module.css';

const Support: React.FC = () => {
  return (
    <div className={styles.supportContainer}>
      <div className={styles.supportContent}>
        <h2 className={styles.supportHeader}>
          <i className="bi bi-chat-quote me-3"></i>
          Support
        </h2>
        <div className={styles.supportInfo}>
          <div className={styles.infoRow}>
            <div className={styles.infoLabel}>Need Help?</div>
            <div className={styles.infoValue}>
              <p className="mb-3">
                If you have any issues or questions, please join our Discord channel and ping our admin.<br />
                We're here to help!
              </p>
              <a 
                href="https://discord.gg/EQm6ZNMPh5" 
                target="_blank" 
                className={styles.discordButton} 
                rel="noreferrer"
              >
                <img src="/discord-icon.png" height={15} alt="Discord icon" />
                <span className={styles.discordLabel}>Join Discord</span>
              </a>
              <a 
                href="https://x.com/valolens" 
                target="_blank" 
                className={styles.twitterButton} 
                rel="noreferrer"
              >
                <img src="/x-icon.png" height={15} alt="X icon" />
                <span className={styles.twitterLabel}>Follow on X</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support; 